function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.999 4.34323C11.249 4.34323 4.46771 10.7526 4.46771 19.4089C4.46771 23.937 6.32396 27.8495 9.34584 30.5526C9.59896 30.7807 9.75209 31.0964 9.76459 31.437L9.84896 34.1995C9.87709 35.0807 10.7865 35.6526 11.5927 35.2995L14.674 33.9401C14.9365 33.8245 15.2271 33.8026 15.5021 33.8776C16.9177 34.2682 18.4271 34.4745 19.999 34.4745C28.749 34.4745 35.5302 28.0651 35.5302 19.4089C35.5302 10.7526 28.749 4.34323 19.999 4.34323ZM29.324 15.9339L24.7615 23.1714C24.0365 24.3214 22.4802 24.6089 21.3927 23.7932L17.7646 21.0714C17.4302 20.8214 16.974 20.8245 16.6427 21.0745L11.7427 24.7932C11.0896 25.2901 10.2333 24.5057 10.674 23.812L15.2365 16.5745C15.9615 15.4245 17.5177 15.137 18.6052 15.9526L22.2333 18.6745C22.5677 18.9245 23.024 18.9214 23.3552 18.6714L28.2552 14.9526C28.9083 14.4557 29.7646 15.2401 29.324 15.9339Z",
  fill: "#495A95"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(3.99896 3.99896)"
})));

var SvgShareMessenger = function SvgShareMessenger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share_messenger.0f46ac00.svg";
export { ForwardRef as ReactComponent };